<template>
	<ThePageLoading v-if="isPageLoading && !isDashboard"></ThePageLoading>
	
	<div class="page-container card col-md-8" :class="{'col-md-12': isDashboard}" v-if="!isPageLoading">
		<ThePageHeader @export-pdf-event="exportPdf" :renderExportReport="!isLoading && pageError == '' && intercompanyEliminationReport != null && intercompanyEliminationReport.content != null" :isExporting="isExporting"  v-if="!isDashboard"></ThePageHeader>
		
		<div class="row p-3" v-if="pageError == ''">
			<div class="col-md-5 d-flex align-items-center">
				<Button type="button" class="p-button-sm" label="Generate" @click="generateReport()"/>
				<span class="p-1"></span>
				<Button class="p-button-sm p-button-secondary" label="Back" @click="back" v-if="!isDashboard" />
			</div>
		</div>
		
		<TheTabViewLoading v-if="isLoading"></TheTabViewLoading>
		
		<div class="row p-3" v-if="pageError == ''">			
			<div class="col-md-12 p-3" v-if="intercompanyEliminationReport != null && intercompanyEliminationReport.content != null">
				<div class="row p-0 mt-0">
					<label style="font-weight: bold;">{{ intercompanyEliminationReport.header.groupName }}</label>
				</div>
                                
				<div class="row m-0 p-0">
					<div class="col p-0">
						<label style="font-weight: bold;">Inter-company Elimination</label>
					</div>
                                    
					<div class="col p-0">
						<label style="font-weight: bold;">Period ended {{ intercompanyEliminationReport.header.date }}</label>
					</div>
				</div>
				
				<div v-for="(sheet, sheetIndex) in intercompanyEliminationReportContents[0]['summary']" :key="sheetIndex">
					<div class="row p-0 mt-3">
						<label style="font-weight: bold;">{{ sheet.name }}</label>
					</div>
				
					<table class="w-100 mt-3">
						<tbody v-for="(content, contentIndex) in intercompanyEliminationReportContents" :key="contentIndex">
							<tr class="border border-dark">
								<td class="p-1 text-center" style="border: 1px solid black; font-weight: bold;" v-for="(title, titleIndex) in content['title']" :key="titleIndex" :colspan="content['title_colspan'][titleIndex]">{{ title }}</td>
							</tr>
							
							<tr v-for="(summary, summaryIndex) in content['summary_' + sheet.code]" :key="summaryIndex" class="border border-dark">
								<td class="p-1" style="border: 1px solid black;" v-for="(value, valueIndex) in summary" :key="valueIndex" :class="{'text-center': valueIndex != 0 && valueIndex != 1 && summaryIndex == 0}" :style="[ valueIndex == 0 || valueIndex == 1 || summaryIndex == 0 ? {'font-weight': 'bold'} : {'width': '12%', 'text-align': 'right'} ]">{{ value }}</td>
							</tr>
							
							<tr class="border border-dark">
								<td class="p-4" colspan="6"></td>
							</tr>
							
							<tr v-for="(details, detailsIndex) in content['details_' + sheet.code]" :key="detailsIndex" class="border border-dark">
								<td class="p-1" style="border: 1px solid black;" v-for="(value, valueIndex) in details" :key="valueIndex" :style="[ valueIndex == 0 || valueIndex == 1 ? {'font-weight': 'bold'} : {'width': '12%', 'text-align': 'right'} ]">{{ value }}</td>
							</tr>
							
							<tr class="border border-dark">
								<td class="p-4" colspan="6">
									<div v-if="contentIndex != intercompanyEliminationReportContents.length - 1" class="html2pdf__page-break"></div>
								</td>
							</tr>
						</tbody>
					</table>
					
					<hr class="mt-4">
				</div>
				
				<div class="row mt-4 p-0">
					<label>Summary:-</label>
				</div>
                                
				<div class="row p-0">
					<label>(Retrieved on {{ formatToReportDateTime(intercompanyEliminationReport.summary.retrievedDate) }})</label>
				</div>
			</div>
			
			<div class="col-md-12 p-4" v-if="!isLoading && intercompanyEliminationReport != null && intercompanyEliminationReport.content == null">
				<div class="error-no-record">
					<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
					<h6><span>No Record Found</span></h6>
				</div>
			</div>
		</div>
		
		<ThePageError @back-event="back" :pageError="pageError" v-if="pageError != ''"></ThePageError>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
    import { useRoute } from "vue-router";
	
    import reportApi from "@/api/reporting/report-api";
    import dateUtilsMixin from "@/mixin/utils/date-utils";
	import roleMixin from "@/mixin/role";
	
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheTabViewLoading from "@/components/TheTabViewLoading.vue";

	import useVuelidate from "@vuelidate/core"
	import { required, minLength, helpers } from "@vuelidate/validators"
	
	export default defineComponent({
        mixins:[dateUtilsMixin, roleMixin],
		components: {
			ThePageHeader,
			ThePageLoading,
			ThePageError,
			TheTabViewLoading,
		},
        data() {
            return {
                pageError: (store.getters.error == undefined ? '' : store.getters.error),
                report: {name: '', isClosed: false},
                reportConfigurationModel: {reportInfoModel: {reportName: null as any}, reportSystemFilterModel: {systemFilterModels: []}, reportUserFilterModel: {userFilterModels: [{isStatic: false, selectionType: '', defaultValue: '', value: null as any, isAllowAll: false, dataType: '', startDate: null as any, endDate: null as any, isHide: false}]}, reportChartModel: {chartType: '', chartFieldModels: [], formattingModel: {showStatistic: false, showDifferentColor: false, showSubTotal: false, showGrandTotal: false}}},
				isLoading: false,
				isPageLoading: true,
                intercompanyEliminationReport: {} as any,
                intercompanyEliminationReportContents: [] as any[],
                session: store.getters.getSession,
				routeQueries: null as any,
				isExporting: false,
            }
        },
        props: {
			identifier: {
				type: String,
				required: false
			},
			reportId: {
				type: String,
				required: false
			},
			isDashboard: {
				type: Boolean,
				required: false
			}
		},
        mounted: function () {
            if (this.pageError == '') {
				if (this.identifier != null && this.reportId != null) {
					this.isPageLoading = true;
					reportApi.reportView(this.identifier, this.reportId)
						.then(response => {
							this.report = response.data.report;
							this.reportConfigurationModel = response.data.reportConfigurationModel;
							
							this.isPageLoading = false;
							
							this.reset();
						})
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				}
			}
        },
        methods: {
			reset() {
				this.intercompanyEliminationReport = {};
				
				this.generateReport();
			},
			generateReport() {
				this.isLoading = true;
					
				if (!this.pageError) {
					reportApi.reportGenerate(this.identifier, this.reportId, {reportConfigurationModel: this.reportConfigurationModel})
						.then(response => {
							this.intercompanyEliminationReport = response.data;
							
							this.intercompanyEliminationReportContents = [];
							let currentPageContent = {} as any;
		
							if (this.intercompanyEliminationReport['content'] != null) {
								var index = 0;
								this.intercompanyEliminationReport['content']['title_colspan'].forEach((rowContent: any, rowIndex: any) => {
									for (var i = 0; i < rowContent; i++) {
										if (index % 2 == 0 && (index / 2) % 2 == 1) {
											currentPageContent = {} as any;
											
											Object.keys(this.intercompanyEliminationReport['content']).forEach((contentKey: any, contentIndex: any) => {
												if (contentKey == 'summary') {
													currentPageContent[contentKey] = this.intercompanyEliminationReport['content'][contentKey];
												}
		
												else if (contentKey != 'title' && contentKey != 'title_colspan') {
													var pageContents = [] as any[];
													if (Array.isArray(this.intercompanyEliminationReport['content'][contentKey])) {
														this.intercompanyEliminationReport['content'][contentKey].forEach((columnContent: any, columnIndex: any) => {
															var contents = [] as any[];
															contents.push(columnContent[0]);
															contents.push(columnContent[1]);
															contents.push(columnContent[index]);
															contents.push(columnContent[index + 1]);
															contents.push(columnContent[index + 2]);
															contents.push(columnContent[index + 3]);
															pageContents.push(contents);
														});
													}
													currentPageContent[contentKey] = pageContents;
												}
												
												else {
													var ccs = [] as any[];
													
													ccs.push(this.intercompanyEliminationReport['content'][contentKey][0]);
													var i = 0;
													while (i < 4) {
														ccs.push(this.intercompanyEliminationReport['content'][contentKey][rowIndex + i]);
														i += this.intercompanyEliminationReport['content']['title_colspan'][rowIndex];
													}
													
													currentPageContent[contentKey] = ccs;
												}
											});
											
											this.intercompanyEliminationReportContents.push(currentPageContent);
										}
										index++;
									}
								});
							}
							
							this.isLoading = false;
						})
						.catch(error => {
							this.isLoading = false;
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						})
				}
					
				else {
					this.isLoading = false;
				}
			},
			back() {
                this.$router.push('/reporting/report');
            },
            exportPdf() {
				this.isExporting = true;
				
				reportApi.reportExport(this.identifier, this.reportId, {reportConfigurationModel: this.reportConfigurationModel})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			}
        },
        setup() {
			return {v$: useVuelidate()}
		},
		validations() {
			return {
				reportConfigurationModel: {
					reportUserFilterModel: {
						userFilterModels: {
							$each: helpers.forEach({
								value: {
									required
								}
							})
						},
					}
				}
			}
		}
	});
</script>